import { createReducer, on } from "@ngrx/store";
import { NAVIGATION } from "../actions/navigation.action";
import { NavigationModel } from "../models/navigation.model";

const INITIAL_STATE: NavigationModel = {
  assessment: {
    type: "", // ** open | closed
    route: "",
    module: "",
    findingId: "",
    assessmentId: "",
  },
  assetRegister: {
    type: "", // ** draft | register
    route: "",
    module: "",
    siteId: "",
    assetId: "",
  },
  mmInventory: {
    type: "",
    route: "",
    module: "",
    siteId: "",
    tabName: "",
  },
};

export const NavigationReducer = createReducer(
  INITIAL_STATE,
  on(NAVIGATION, (_, { navigation }) => navigation),
);
